import React from 'react';
import { MethodEnum } from 'axios/type';
import useAxios from 'axios/useAxios';
import Button from 'tradevan-ui/Button';
import { IorderDownloadPreviewRequest } from '../OrderQuery/components/ResultSecion/components/DownloadPdf/type';
import { IreceiveDownloadPreviewRequest } from '../RcvQuery/components/ResultSecion/type';
import { IreturnsDownloadPreviewRequest } from '../RtnQuery/components/ResultSecion/type';

interface IorderDownload {
  pageName: 'order';
  request: IorderDownloadPreviewRequest;
}
interface IreceiveDownload {
  pageName: 'receive';
  request: IreceiveDownloadPreviewRequest;
}
interface IreturnsDownload {
  pageName: 'returns';
  request: IreturnsDownloadPreviewRequest;
}

type DownloadPdfButtonProps =
  | IorderDownload
  | IreceiveDownload
  | IreturnsDownload;

/** 呼叫下載PDF API (有計次功能) */
const DownloadPdfButton = (props: DownloadPdfButtonProps) => {
  const { pageName, request } = props;
  const axios = useAxios();

  const handleDownload = async () => {
    const response = await axios.blobAxios(
      MethodEnum.post,
      `${pageName}/download`,
      request,
    );
    axios.blobDownload(response);
  };

  return <Button onClick={handleDownload}>下載</Button>;
};

export default DownloadPdfButton;
